import React from 'react'
import Navbar from '../Components/Navbar'
import Team from '../Components/Team'
import Footer from '../Components/Footer'

const MetTeam = () => {
  return (
    <>
    <Navbar/>
    <Team/>
    <Footer/>
    </>
  )
}

export default MetTeam
